module.exports = __webpack_public_path__ + "static/media/chart-81k-v2@4x.194bf036.png";